module.exports = __webpack_public_path__ + "static/media/portfolio-website.84576067.svg";